export const SAMPLING_TYPE = {
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
};

export const NUMBER_TYPE = {
  RATE: 'RATE',
  STATIC: 'STATIC',
};

export const PAGE_TARGETING_ENABLED_TYPE = {
  RECORD_ALL: 'RECORD_ALL',
  RECORD_SPECIFIC: 'RECORD_SPECIFIC',
  RECORD_BY_JS: 'RECORD_BY_JS',
};

export const SITE_SETTINGS_TAB = {
  RECORDINGS: {
    label: 'Recordings',
    path: 'recordings',
  },
  TRACKING: {
    label: 'Advanced Tracking',
    path: 'tracking',
  },
  API: {
    label: 'API Keys',
    path: 'api',
  },
  INSTALLATION: {
    label: 'Check Installation',
    path: 'check-script',
  },
  NOTIFICATIONS: {
    label: 'Notifications',
    path: 'notifications',
  },
};

export function getDefaultSiteSettingsTab({
  canViewRecordings = false,
  canVisitTracking = false,
  canVisitApi = false,
  canVisitCheckInstall = false,
  canVisitNotifications = false,
} = {}) {
  if (canViewRecordings) return SITE_SETTINGS_TAB.RECORDINGS.path;
  if (canVisitTracking) return SITE_SETTINGS_TAB.TRACKING.path;
  if (canVisitApi) return SITE_SETTINGS_TAB.API.path;
  if (canVisitCheckInstall) return SITE_SETTINGS_TAB.INSTALLATION.path;
  if (canVisitNotifications) return SITE_SETTINGS_TAB.NOTIFICATIONS.path;

  return null;
}
